import { odinClient } from "@/config/client"

export interface UpdateDiagnosticsParams {
  id: string
  index: number
  question: string
  payload: UpdateDiagnosticsAnalysisRequest | UpdateDiagnosticsMultipleChoiceRequest
}

export interface UpdateDiagnosticsAnalysisRequest {
  answer: string
}

export interface UpdateDiagnosticsMultipleChoiceRequest {
  answerIndex: number
  options: string[]
}

export function update(params: UpdateDiagnosticsParams) {
  return odinClient.put(`/v1/activities/${params.id}/diagnostic/${params.index}`, {
    question: params.question,
    ...("answer" in params.payload && { answer: params.payload.answer }),
    ...("answerIndex" in params.payload && { answerIndex: params.payload.answerIndex }),
    ...("options" in params.payload && { options: params.payload.options }),
  })
}
